import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import {ApiCallsService, ApiObject} from './api-calls.service';

/**
 * Article interface,
 */

export interface Article extends ApiObject {
  attributes: {
    title: string;
    content: string;
    bg: string;
    image?: string;
    fileLink?: string;
    shown: boolean;
    imageIsFile?: boolean;
    gallery?: boolean;
    images?: string[];
    order?: number;
    picture_text?: string;
    showTitle?: boolean;
    summary?: string;
    date?: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class ArticlesService {
  private apiCalls = inject(ApiCallsService);


  /**
   * getters for all of the various articles across the site
   */

  getArticles(type) {
    return this.apiCalls.getData({type});
  }

  getTitle() {
    return this.apiCalls.getData({type: 'title'});
  }

  getBlogPost(id: string) {
    return this.getArticles('blog').pipe(
      map((posts: Article[]) => posts.find(post => post.id === id))
    );
  }

  /**
   * saves the data from all articles to the firebase server
   *
   * @param data
   * @todo alerts service for responses
   */
  saveArticles(data) {

    if (data.id) {
      this.apiCalls.updateData(data).subscribe(
        response => {
          console.log('saved data ', data);
        },
        errors => { console.log(errors); }
      );
    } else {
      this.apiCalls.setData(data).subscribe(
        response => {
          console.log('saved data ', data);
        },
        errors => { console.log(errors); }
      );
    }
    this.getArticles(data.type);

  }

  deleteArticle(data: { type: string; id: string }) {
    return this.apiCalls.deleteData(data);
  }

  saveTitle(data) {

    if (data.id) {
      this.apiCalls.updateData(data).subscribe(
          response => {
            console.log('saved data ', data);
          },
          errors => {
            console.log(errors);
          }
      );
    } else {
      this.apiCalls.setData(data).subscribe(
          response => {
            console.log('saved data ', data);
          },
          errors => {
            console.log(errors);
          }
      );
    }
  }
}
